<div class="form-container">

  <div class="form-header">
    <div class="header-title">
      <span>Configure Taxonomy</span>
    </div>

    <div class="header-actions">
      <button class="btn-save" [disabled]="!isSaveEnabled()" (click)="handleSaveChanges()">
        <span>Save</span>
      </button>
      <button class="btn-close" (click)="handleClosePress()">
        <img src="assets/icons/close-icon-grey.svg" alt="close">
      </button>
      <button class="btn-delete" (click)="handleDeletePress()">
        <img src="assets/icons/delete-icon-red.svg" alt="delete">
      </button>
    </div>
  </div>

  <div class="form-body">

    <!-- Taxonomy Name & Description -->
    <div class="taxonomy-details">
      <div class="field-class">
        <div class="label-class"><label>Taxonomy Name <span class="required-star">*</span></label></div>
        <div class="input-class">
          <input type="text" [(ngModel)]="taxonomy.name" name="taxonomyName" placeholder="Enter taxonomy name"
            class="custom-input" required (ngModelChange)="onNameChange($event)" />
        </div>
      </div>

      <div class="field-class">
        <div class="label-class"><label>Taxonomy Description</label></div>
        <div class="input-class">
          <textarea class="custom-input-description"
            placeholder="Enter a description of this taxonomy and explain what it is applied to"
            [(ngModel)]="taxonomy.description" name="taxonomyDescription" rows="4"
            (ngModelChange)="onDescriptionChange($event)">
        </textarea>
        </div>
      </div>
    </div>

    <div class="segment"></div>

    <!-- Queue Group -->
    <div class="queue-details">
      <div class="field-class">
        <div class="label-class"><label>Queues</label></div>
        <div class="input-class">
          <mat-form-field appearance="outline" class="full-width">
            <mat-select [formControl]="queueGroups" multiple (openedChange)="onDropdownToggle($event)"
              placeholder="Select queue names">
              <!-- Trigger shows count -->
              <mat-select-trigger>
                <div class="selected-indicator">
                  <span>{{ selectedGroups.length }}</span>
                  <span>selected</span>
                </div>
              </mat-select-trigger>

              <!-- Custom Search Input (using ng-container) -->
              <ng-container>
                <div class="search-container" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Search queue group" [(ngModel)]="searchText"
                      (ngModelChange)="filterQueueGroups()" class="search-input" />
                  </mat-form-field>
                </div>
              </ng-container>

              <!-- Selected -->
              <mat-optgroup *ngIf="filteredQueueGroups.selected.length" label="Selected">
                <mat-option *ngFor="let group of filteredQueueGroups.selected" [value]="group.name"
                  (click)="onGroupSelectChange(group, $event)">
                  <div class="queue-option">
                    <mat-checkbox [checked]="group.selected" *ngIf="!group.isLocked">{{ group.name }}</mat-checkbox>
                  </div>
                </mat-option>
              </mat-optgroup>

              <!-- Unselected -->
              <mat-optgroup *ngIf="filteredQueueGroups.unselected.length" label="Unselected">
                <mat-option *ngFor="let group of filteredQueueGroups.unselected" [value]="group.name"
                  (click)="onGroupSelectChange(group, $event)">
                  <div class="queue-option">
                    <mat-checkbox [checked]="group.selected" *ngIf="!group.isLocked">{{ group.name }}</mat-checkbox>
                  </div>
                </mat-option>
              </mat-optgroup>

              <!-- Locked -->
              <mat-optgroup *ngIf="filteredQueueGroups.locked.length" label="Locked">
                <mat-option *ngFor="let group of filteredQueueGroups.locked" [value]="group.name" [disabled]="true">
                  <div class="locked-option-content">
                    <div class="locked-icon">
                      <img src="assets/icons/lock-queue.svg" alt="locked" class="lock-icon">
                    </div>
                    <div class="locked-text">
                      <span class="queue-name">{{ group.name }}</span>
                      <span class="taxonomy-name">Assigned Taxonomy: {{ group.taxonomyName }}</span>
                    </div>
                  </div>
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>

          <!-- Selected Groups Display -->
          <div *ngIf="selectedGroups.length > 0" class="selected-options">
            <div *ngFor="let selected of selectedGroups" class="selected-option">
              <span>{{ selected }}</span>
              <button type="button" (click)="deselectOption(selected)" class="deselect-btn">
                <img src="../../../../../assets/icons/close.svg" alt="cross-icon">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<!-- Save Confirmation Popup -->
<div class="confirmation-popup" *ngIf="showConfirmationPopup">
  <div class="popup-content">
    <h3>Save Changes</h3>
    <p>Are you sure you want to save the changes made to this taxonomy?</p>
    <div class="popup-actions">
      <button class="btn-cancel" (click)="cancelSave()">Cancel</button>
      <button class="btn-confirm" (click)="confirmSaveChanges()">Save Changes</button>
    </div>
  </div>
</div>

<!-- Delete Confirmation Popup -->
<div class="confirmation-popup" *ngIf="showDeleteConfirmationPopup">
  <div class="popup-content">
    <div class="heading">
      <img src="assets/icons/save-alter.svg" alt="warning-icon">
      <span>Delete Taxonomy</span>
    </div>
    <p>Are you sure you want to delete this taxonomy? This action cannot be undone.</p>
    <div class="popup-actions">
      <button class="btn-confirm" (click)="handleDeleteTaxonomy()">Delete</button>
      <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
    </div>
  </div>
</div>
